var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    "data-name": "Warstwa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 347.81 347.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-6{fill:#fff;}.cls-2,.cls-3,.cls-4{fill:#f7f7f7;}.cls-11,.cls-12,.cls-3,.cls-4,.cls-6{stroke:#5f5f5e;stroke-width:0.25px;}.cls-11,.cls-3{stroke-linecap:round;}.cls-11,.cls-12,.cls-15,.cls-3,.cls-4,.cls-6{stroke-miterlimit:10;}.cls-11,.cls-12,.cls-5{fill:none;}.cls-7{fill:#3259a5;}.cls-8{fill:#8b8b8c;}.cls-9{fill:#ededed;}.cls-10{fill:#fdfdfd;}.cls-13,.cls-15{fill:#b93f36;}.cls-14{opacity:0.25;}.cls-15{stroke:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1256",
    "data-name": "Group 1256"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    className: "cls-1",
    cx: 173.91,
    cy: 173.82,
    r: 164.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    className: "cls-2",
    d: "M9.43,196.5l0-5.46,2.19.23,6,5.15.59,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    className: "cls-2",
    d: "M192.2,196.75l0-5.46-2.2.23-6,5.15-.6,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    className: "cls-2",
    d: "M9.43,196.5a2.66,2.66,0,0,0,0,.69c0,7.48,38.77,13.58,87.39,13.9h4q3.24,0,6.43,0c47.49-.5,85-6.53,85-13.89a2.15,2.15,0,0,0-.09-.61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    className: "cls-3",
    d: "M9.43,196.5a2.66,2.66,0,0,0,0,.69c0,2.92,5.9,5.62,16,7.86,15.76,3.5,41.75,5.85,71.4,6l4,0q3.24,0,6.42,0c24.55-.25,46.43-2,61.84-4.62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    className: "cls-2",
    d: "M9.43,191.13c0,7.69,40.93,13.92,91.43,13.92s91.42-6.23,91.42-13.92a1.59,1.59,0,0,0-.09-.61,5.47,5.47,0,0,0-2.74-2.84c-10.1-6-45.94-10.47-88.59-10.47s-78.49,4.45-88.59,10.47a5.54,5.54,0,0,0-2.75,2.83A2.21,2.21,0,0,0,9.43,191.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    className: "cls-3",
    d: "M30.56,182.23c-8.54,1.57-14.88,3.42-18.28,5.45a5.45,5.45,0,0,0-2.75,2.84,2.1,2.1,0,0,0-.09.61c0,7.69,40.93,13.92,91.43,13.92s91.42-6.23,91.42-13.92a2.1,2.1,0,0,0-.09-.61,5.52,5.52,0,0,0-2.75-2.84c-2.64-1.58-7-3-12.87-4.35a207.23,207.23,0,0,0-22-3.46c-7.65-.85-16.19-1.52-25.37-2-8.92-.44-18.44-.68-28.33-.68-11.1,0-21.73.3-31.57.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    className: "cls-4",
    d: "M96.82,211.09l.2,115.8h10.47l-.2-115.81c-2.12,0-4.27,0-6.43,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    className: "cls-2",
    d: "M85.1,319.24h35a11.9,11.9,0,0,1,11.9,11.9H73.2a11.9,11.9,0,0,1,11.9-11.9Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    className: "cls-5",
    x1: 192.23,
    y1: 191.61,
    x2: 192.28,
    y2: 197.18
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    className: "cls-6",
    d: "M222.75,177.92c.09.2-1.27,1.9-1.4,2.14-1.43,2.64-2.46,5.3-4.17,7.61s-3.06,4.78-5.67,6.13c-1.6.83-3.51.28-5.4,0-7.91-1.07-16.08-4.92-22.72-9.19-5.54-3.56-9.82-7.63-14.42-12.12-.7-.68-1.3-1.46-1.93-2.15a22.14,22.14,0,0,0-1.77-2,3.82,3.82,0,0,0-.86-.58,3.16,3.16,0,0,0-1.44-.35.94.94,0,0,1-.37,0,7.76,7.76,0,0,1-2.43-2.13l-7.88-8.34c-.23-.24-.67-.65-.88-.92a1.5,1.5,0,0,1,0-2.12l.05-.05a1.65,1.65,0,0,1,2.22,0l-.4-.41a.28.28,0,0,1-.09-.1,2.18,2.18,0,0,1,0-3c.88-.89,1.8-.7,2.84-.34a1.64,1.64,0,0,1,.34.27c.05,0-.15-.15-.17-.18s-.1-.09-.12-.13a2.12,2.12,0,0,1,.16-2.9,2.44,2.44,0,0,1,3-.2c.08,0,.15.14.2.17s.29.3.27.25-.3-.29-.33-.51c-.15-1-.41-1.7.54-2.44a2.44,2.44,0,0,1,3.23.13c.36.3.75.7,1.24,1.18s1.28,1.26,1.83,1.87,1.12,1.35,1.65,2c0,0,1.12-.3,1.21-.32a3.62,3.62,0,0,1,3.22.44,5.09,5.09,0,0,1,1.7,3.43,6.77,6.77,0,0,1-.06,2c-.09.49-.63,1.4-.37,1.86a16.4,16.4,0,0,0,1.17,1.57c.06.09.28.34.4.49a48.28,48.28,0,0,0,5.6,5.66c1.56,1.37,4.49,3.19,5.69,4.19,3.6,3,10.68,7.29,14.17,7.31,5.17,0,3-2.36,5.68-4.66.11-.1-.07-.14,0-.18a.15.15,0,0,0,.08-.12,6.26,6.26,0,0,0,1.47-3.86C214.6,168.77,220,171.17,222.75,177.92Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    className: "cls-4",
    d: "M294.17,252.66c-5-2.91-33.21-27.58-32.82-35.94.17-3.65,4.71-9.74,6.25-13.26,11.56-26.66,13.48-28,21.11-67.31,1.81-9.3,2.83-24.25,13.08-19.18,4.44,2.51,24.76,12,25.64,15a.64.64,0,0,0-.1-.13c-2-2.65-9.34-4.93-12.2,7.14-4.84,20.44-2.26,40.11-15.68,87.65,0,0-8.75,24-5.28,26Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    className: "cls-6",
    d: "M243.86,132.48l-4.29-18.09-8.78,9.27.73,10.56.32,8.09,1.92,5.13,3.78,1.12,6-4.81,1.75-7.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    className: "cls-7",
    d: "M230.82,210.61l-4.39-31.8a.1.1,0,0,0-.09-.07s-.05,0-.06,0l-1.63,4.81a.08.08,0,0,1-.1.05h0L204.1,172.88a.07.07,0,0,1,0-.08c.37-1.47,8.06-32.12,18.42-36.13a54.54,54.54,0,0,1,9.05-2.46h0s.92,12.2,4.82,12.2,7.4-10.22,7.51-13.88a.07.07,0,0,1,.07-.07,101.44,101.44,0,0,1,14.58-.6c4.22.4,12.67,1.9,18.52,20.45s6.78,51.31,6.56,55.1c0,0,4.65,6.83-52.7,3.26A.07.07,0,0,1,230.82,210.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    className: "cls-6",
    d: "M141,282.93l-8.59,11.44,9.26,8.12,9.3-11Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    className: "cls-6",
    d: "M241.57,105.49a60.52,60.52,0,0,1-.4,12.62,11.88,11.88,0,0,1-4.56,7.77l-.46.34a8.53,8.53,0,0,1-9.13.8h0a11.88,11.88,0,0,1-6-7.43,88.11,88.11,0,0,1-2.17-12.38s-2-12.69,10.26-13.37S241.57,105.49,241.57,105.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    className: "cls-8",
    d: "M237.74,113.62l-1.13-4.1a2.12,2.12,0,0,0-.72-1.09,11.41,11.41,0,0,1-4.09-6c-20.51,11.23-28,.81-28,.81a8.65,8.65,0,0,0,4-.54c-2.32,0-7.16-4-6.15-9,0,0,.76,2.53,4.38,2,0,0-2.18-.55-2.76-1.74,0,0,2.79,1.2,8.38-3.34.5-.4,1.08-.84,1.71-1.28a16.14,16.14,0,0,1,2.65-1.66c6.59-3.68,16.5-7.29,21.68,5.25a5.56,5.56,0,0,1,.29.71s4.77-1.18,5.88,7c.42,3.1-.63,6.28-1.6,10.43a24.94,24.94,0,0,1-.82,3.08l-.56,1.9a.46.46,0,0,1-.4.32h0a2.58,2.58,0,0,1-2.71-2.23Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    className: "cls-9",
    d: "M163.08,100.65v67.13c0,3.68-1.6,5.34-4.88,5.34H44.75c-3.29,0-4.89-1.39-4.89-5.08V100.92c0-3.69,1.6-5.09,4.89-5.09H158.2C161.48,95.83,163.08,97,163.08,100.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    className: "cls-10",
    d: "M39.86,166.27V168c0,3.68,1.6,5.08,4.89,5.08H158.19c3.29,0,4.89-1.66,4.89-5.35v-1.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    className: "cls-1",
    x: 43.85,
    y: 99.34,
    width: 115.23,
    height: 62.63
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    className: "cls-9",
    d: "M115.84,186.15H87.11c-1.26,0-1.76-.74-1.1-1.66l2.72-2.34a4.06,4.06,0,0,0,1.42-2.78l.52-6.25h21.39l.69,6.32a4.09,4.09,0,0,0,1.41,2.67l2.78,2.38C117.6,185.41,117.1,186.15,115.84,186.15Z"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    className: "cls-11",
    x1: 226.43,
    y1: 178.81,
    x2: 234.04,
    y2: 161.52
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    className: "cls-6",
    d: "M182.37,165.92c3.22,1,6.51,1.86,9.81,2.63l2.89.68q4.59,1.08,9.2,2.13l8.91,2,6.91,1.54c1,.23,2.11.51,3.17.66,1.84.24,14.07-10.67,14.07-10.67a66,66,0,0,0,13.53,17.32s-13.32,10.07-24.44,11.57a8.54,8.54,0,0,1-3.14-.32c-1.91-.38-3.79-.88-5.67-1.39-2.46-.66-4.9-1.38-7.34-2.12-2.73-.82-5.46-1.67-8.17-2.54s-5.44-1.76-8.16-2.65a191.63,191.63,0,0,1-20.84-8.12l-.3-.17a3.22,3.22,0,0,0-2.65-.38c-.26.13-.59.5-.88.57-.89.21-2.09-.56-2.89-.87l-9.73-3.91-1.13-.46a1.51,1.51,0,1,1,1.13-2.8l-.56-.23-.08,0a2.14,2.14,0,0,1,1.6-4l-.26-.11a2.14,2.14,0,1,1,1.6-4l.4.16-.06,0-.25-.15-7.28-4.12a1.69,1.69,0,0,1-.64-2.3,1.65,1.65,0,0,1,1.28-.85,1.79,1.79,0,0,1,.86.12l8.58,3.71.73.3,2.4,1c1.5.6,4.48,2,5.34,2.37l-3.56-1.74a.26.26,0,0,1-.14-.35.22.22,0,0,1,.07-.09c1.24-1.06,6-4.31,8.94,4.59a1.23,1.23,0,0,0,0,.2.2.2,0,0,0,.1.2l.2.11a18,18,0,0,0,1.72.81Q180,165.16,182.37,165.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    className: "cls-6",
    d: "M186.93,219.63s-5.84-7.92-45.92,61.57l13.65,9.54s32.72-29.73,36-35.18S186.93,219.63,186.93,219.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    className: "cls-6",
    d: "M223.17,297.68l6.7,10.32,10.56-5.79-6.5-11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    className: "cls-2",
    d: "M225.52,301.67c2.34,1.24,9.85,4,13.09-3.77.13-.33.53-.34.81,0,1.58,2,3.71,4.52,5.4,6.55a44.53,44.53,0,0,1,4.91,7.24h0l-34.08,18.5h0c-1.36-2.51-1.19-5.34.37-6.75,3.85-3.45,9.75-10.61,8.83-21.27C224.82,301.73,225.14,301.46,225.52,301.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    className: "cls-2",
    d: "M138.58,286.18c-.13,2.64.57,10.6,8.94,10.27.36,0,.53.34.34.74-1.1,2.25-2.53,5.27-3.65,7.66a45.58,45.58,0,0,1-4.5,7.5h0l-31.15-23.08h0c1.7-2.29,4.34-3.33,6.27-2.51,4.76,2,13.74,4.35,23-1C138.23,285.56,138.61,285.75,138.58,286.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    className: "cls-6",
    d: "M230.82,210.67s-50.47-3.14-52.42,18,20.61,31.2,39.3,68.24l18.55-9.1s-20.8-35.42-20.64-37.7,1-4.22,5-3.41,59.86,13.77,62.77-38.27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    className: "cls-7",
    x: 214.12,
    y: 290.17,
    width: 26.46,
    height: 6.5,
    rx: 1,
    transform: "translate(-89.13 99.46) rotate(-20.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    className: "cls-7",
    x: 144.69,
    y: 272.46,
    width: 6.5,
    height: 26.46,
    rx: 1.02,
    transform: "translate(-165.04 211.21) rotate(-49.24)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    className: "cls-11",
    x1: 237.29,
    y1: 164.97,
    x2: 250.04,
    y2: 151.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    className: "cls-11",
    x1: 250.87,
    y1: 182.24,
    x2: 266.12,
    y2: 167.51
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    className: "cls-4",
    x: 270.52,
    y: 259.64,
    width: 9.05,
    height: 68.52
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    className: "cls-2",
    d: "M268.68,318.24H281a13.29,13.29,0,0,1,13.28,13.28H255.4A13.29,13.29,0,0,1,268.68,318.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    className: "cls-2",
    d: "M298.14,243.86s2.93,14.75-9.42,16.5-31.1,2.76-31.1,2.76-9.27-.8-6.1-12.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    className: "cls-4",
    d: "M218,255.08a11.66,11.66,0,0,0,3.32,1.23,5.06,5.06,0,0,0,.68.1c1.3.13,3.9.22,6.63.27,3.83.08,7.92.11,9,.14,5,.12,8.89.07,11.16-.05,8-.41,16-1.31,24-2.16l6.86-.7,2-.2,6.91-.64,9.92-.91h0c1.35-.12,2.5-3,3.42-6.7a156.32,156.32,0,0,0,2.9-19.13q.5-3,1-5.76c8-44.42,18.2-60.7,22.35-80.46,2.57-12.18-7.55-12-10.6-10.39l-.13.08c-2.21,1.21-4.07,4-6.53,8.71-7.9,15.14-14.28,42-18.32,61.9-.31,1.39-.62,2.79-.92,4.19-.69,3.18-1.34,6.36-1.95,9.57q-.75,3.92-1.43,7.85c-.32,1.84-.63,3.67-.92,5.51-.11.66-.22,1.35-.37,2a6.92,6.92,0,0,1-1.63,3.49,4.93,4.93,0,0,1-2.41,1.21c-.38.09-.77.16-1.15.23l-1.17.2q-3.24.57-6.75,1c-10.31,1.41-22,2.38-32.72,3.67-1.66.3-11.26,1.34-14.87,1.82-.52.07-.92.13-1.15.18q-2.68.49-5.14,1l-1.12.22-.23,0a3.14,3.14,0,0,0-2.37,2.06C215.11,248.48,215.17,253.23,218,255.08Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    className: "cls-12",
    x1: 167.88,
    y1: 149.5,
    x2: 170.79,
    y2: 153.03
  })), /*#__PURE__*/React.createElement("g", {
    id: "_404",
    "data-name": 404
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    className: "cls-13",
    d: "M99.79,135.6l6.85-16.2h4.11v16.2h1.78V139h-1.78v4.36H107V139H99.79Zm7.19,0v-8.87l-3.73,8.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    className: "cls-13",
    d: "M113.93,125.15c0-3.83,2-6,5.72-6s5.72,2.19,5.72,6v12.47c0,3.83-2,6-5.72,6s-5.72-2.19-5.72-6Zm3.77,12.7c0,1.71.75,2.36,2,2.36s1.95-.65,1.95-2.36V124.91c0-1.71-.75-2.36-1.95-2.36s-2,.65-2,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    className: "cls-13",
    d: "M126.91,135.6l6.85-16.2h4.1v16.2h1.78V139h-1.78v4.36h-3.77V139H126.9Zm7.19,0v-8.87l-3.73,8.87Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_8",
    "data-name": "Layer 8",
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    className: "cls-13",
    d: "M84.82,145.2l-.1-1.41v0c0-.15-.27-.33-.59-.43l-2.07-.61-.09,0c-.2-.08-.34-.19-.34-.29a2.47,2.47,0,0,0-.7-1.49.05.05,0,0,1,0,0c0-.06,0-.11.17-.12l1-.12c.14,0,.19-.07.15-.13a.1.1,0,0,0-.06-.05l-.93-.64a1.08,1.08,0,0,0-.5-.12l-1.34,0a.83.83,0,0,1-.38-.07l-.44-.18c-.28-.1-.56-.2-.85-.28h0c-.11,0-.17-.08-.14-.13l.26-.36v0s-.05-.1-.2-.11l-1.18-.19a.63.63,0,0,0-.36,0l-.56.28a.69.69,0,0,1-.32,0,14.17,14.17,0,0,0-1.6-.08.45.45,0,0,1-.28-.07l-.22-.29a.45.45,0,0,0-.3-.07l-1.18.05c-.14,0-.25,0-.26.08l-.11.41s-.09.08-.2.1l-.42.07c-.26.06-.52.11-.76.18a.88.88,0,0,1-.36,0l-1.18-.22a.93.93,0,0,0-.44,0l-1.11.41c-.13,0-.17.11-.1.15h0l.9.34c.08,0,.1.09,0,.15h0l-.07,0a5.61,5.61,0,0,0-.8.58.86.86,0,0,1-.44.15l-1.62.16a.94.94,0,0,0-.56.21l-.17.19-.64.73c-.11.13,0,.22.26.22l1.9,0c.2,0,.33.05.33.15a1.94,1.94,0,0,0,.16.82,2.41,2.41,0,0,0,.38.63l-.39.27-1.79,1.24c-.25.17-.36.38-.27.52a.22.22,0,0,0,.09.07l1.88,1.18a1.08,1.08,0,0,0,1-.16l1.6-1.13a1,1,0,0,1,.84-.16,14.31,14.31,0,0,0,3.55.63.64.64,0,0,1,.62.4l.89,2.84a.92.92,0,0,0,1,.61l3.71-.47a.54.54,0,0,0,.52-.55.55.55,0,0,0-.07-.25L78.34,146a.33.33,0,0,1,.15-.44l.07,0A8.22,8.22,0,0,0,79.8,145c.18-.11.36-.22.54-.35a.78.78,0,0,1,.6,0l3.19.82C84.53,145.48,84.83,145.4,84.82,145.2Zm-8-5a2.78,2.78,0,0,1,.7.58,1,1,0,0,1,.1.17.85.85,0,0,1-.05.86c-1.74,2.36-8.16,1.6-7.9-.69,0,0,0-.06,0-.09a1.62,1.62,0,0,1,.78-.83,3.68,3.68,0,0,1,.57-.26A7.79,7.79,0,0,1,76.85,140.19Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    className: "cls-13",
    d: "M85,144.43l-.1-1.41v0c0-.14-.27-.33-.59-.42L82.19,142l-.09,0c-.2-.08-.34-.19-.34-.29a2.39,2.39,0,0,0-.7-1.48l0-.05c0-.06,0-.11.18-.13l1-.12c.13,0,.18-.06.15-.12l-.06-.06-.93-.64a1.13,1.13,0,0,0-.51-.12l-1.34,0a1,1,0,0,1-.38-.07,3.38,3.38,0,0,0-.44-.18c-.27-.11-.56-.2-.84-.29h0c-.12,0-.18-.08-.15-.12l.27-.37h0c0-.05-.06-.1-.2-.12l-1.18-.19a.78.78,0,0,0-.37,0l-.55.28a.6.6,0,0,1-.32,0c-.53-.05-1.07-.08-1.6-.08a.43.43,0,0,1-.29-.07l-.21-.29a.4.4,0,0,0-.3-.06l-1.18,0c-.14,0-.26,0-.27.08l-.11.42s-.08.07-.2.09l-.41.08-.77.17a.87.87,0,0,1-.36,0l-1.18-.22a1,1,0,0,0-.44,0l-1.11.41c-.12,0-.16.11-.1.14l0,0,.89.33c.09,0,.1.09,0,.15h0l-.07.05a5,5,0,0,0-.79.57.8.8,0,0,1-.44.15l-1.62.16a1,1,0,0,0-.57.21l-.17.19-.64.74c-.11.12,0,.22.26.21l1.9,0c.2,0,.33.06.33.15a2.1,2.1,0,0,0,.16.82,2.52,2.52,0,0,0,.38.63l-.38.27-1.79,1.24c-.25.17-.36.38-.27.52a.24.24,0,0,0,.09.08L66,146.34a1.06,1.06,0,0,0,1-.16l1.6-1.13a1,1,0,0,1,.84-.16,13.78,13.78,0,0,0,3.55.63.64.64,0,0,1,.62.4l.88,2.84a.94.94,0,0,0,1,.61l3.71-.47a.54.54,0,0,0,.52-.55.67.67,0,0,0-.07-.24l-1.23-2.89a.32.32,0,0,1,.15-.43s0,0,.07,0a8.22,8.22,0,0,0,1.24-.58,4.41,4.41,0,0,0,.53-.35.81.81,0,0,1,.61-.05l3.19.83C84.66,144.71,85,144.63,85,144.43Zm-8-5a2.78,2.78,0,0,1,.7.58.59.59,0,0,1,.1.17.87.87,0,0,1,0,.87c-1.74,2.36-8.16,1.6-7.9-.7,0,0,0-.05,0-.08a1.64,1.64,0,0,1,.78-.84,3.68,3.68,0,0,1,.57-.26A7.79,7.79,0,0,1,77,139.42Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    className: "cls-15",
    d: "M93.63,136.13,95,133.71l0-.06a.67.67,0,0,0-.18-.87L93,131.39l-.08-.07a.63.63,0,0,1-.13-.71,11.71,11.71,0,0,0,.92-4.52.57.57,0,0,1,0-.18.67.67,0,0,1,.48-.46l1.9-.46a.67.67,0,0,0,.49-.5.86.86,0,0,0,0-.23l-.37-2.83a.7.7,0,0,0-.71-.6L93,121a.66.66,0,0,1-.61-.36,10.38,10.38,0,0,0-.57-1A12.39,12.39,0,0,0,90.51,118h0a.67.67,0,0,1-.13-.76l1.13-2.38,0-.12a.65.65,0,0,0-.26-.85l-2.47-1.44a.68.68,0,0,0-.89.18l-1.55,2.09a.65.65,0,0,1-.74.24,12,12,0,0,0-3.57-.55.66.66,0,0,1-.64-.51l-.55-2.25a.69.69,0,0,0-.75-.52l-2.85.37a.64.64,0,0,0-.56.67l.12,3a.65.65,0,0,1-.35.62c-.28.16-.55.32-.82.5a10.85,10.85,0,0,0-1.42,1.11.66.66,0,0,1-.73.11l-2.86-1.36a.66.66,0,0,0-.86.27L68.36,119a.65.65,0,0,0,.11.8.23.23,0,0,0,.07.07l2.32,1.72a.66.66,0,0,1,.24.75,1.52,1.52,0,0,0-.06.2,11.25,11.25,0,0,0-.5,2.44.65.65,0,0,1-.5.57l-2.38.58a.66.66,0,0,0-.51.74l.08.63.28,2.2a.68.68,0,0,0,.7.59l2.55-.11a.67.67,0,0,1,.63.4,11.42,11.42,0,0,0,1,1.92,10.67,10.67,0,0,0,1,1.3l-.23.5-1,2.05a.67.67,0,0,0,.12.75.71.71,0,0,0,.14.1L75,138.63a.67.67,0,0,0,.87-.18L76.89,137a.67.67,0,0,1,.78-.22,11.75,11.75,0,0,0,3.6.85.64.64,0,0,1,.59.5l.69,2.84a.64.64,0,0,0,.71.48l2.87-.37a.66.66,0,0,0,.58-.68l-.14-3.17a.66.66,0,0,1,.39-.63,10.51,10.51,0,0,0,1.57-.88q.41-.27.78-.57a.68.68,0,0,1,.7-.08l2.75,1.3A.69.69,0,0,0,93.63,136.13Zm-5.94-12.91a7.32,7.32,0,0,1,.72,2.34c0,.2,0,.41,0,.61a6.33,6.33,0,0,1-12.62.62c0-.1,0-.2,0-.31a6.08,6.08,0,0,1,.66-3.27,8.37,8.37,0,0,1,.84-1.18,6.29,6.29,0,0,1,10.41,1.19Z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.8ed2a4da.svg";
export { ForwardRef as ReactComponent };